module.exports = __webpack_public_path__ + "img/dingle-thumb.31d3cf49.jpg";